import React from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import moment from 'moment-timezone';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);

export default function SalesChart(props) {
    const rawData = props.data;
    let labels = [];
    let data = [];
    let tempData = {};
    let scalesX = false;

    rawData.map((v) => {
        const count = v.count;//Math.floor(Math.random() * 101);
        if (props.salesDateBetween === '1-week' || props.salesDateBetween === '1-month') {
            labels.push(moment(v.date).format('DD.MM.YYYY'));
            data.push(count);
        } else if (props.salesDateBetween === '3-month' || props.salesDateBetween === '1-year' || props.salesDateBetween === 1 || props.salesDateBetween == 2 || props.salesDateBetween === 3) {
            const date = moment(v.date).format('MM.YYYY').toString();
            tempData[date] = tempData[date] ? parseInt(tempData[date]) + count : count;
        }
    });

    if (props.salesDateBetween === '3-month' || props.salesDateBetween === '1-year' || props.salesDateBetween === 1 || props.salesDateBetween == 2 || props.salesDateBetween === 3) {
        Object.keys(tempData).map((key) => {
            labels.push(key);
            data.push(tempData[key]);
        });
        scalesX = true;
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            y: {
                display: true,
            },
            x: {
                display: scalesX || props.salesDateBetween === '1-week',
            },
        },
    };

    const resultData = {
        labels,
        datasets: [
            {
                data,
                label: 'Satış',
                backgroundColor: '#FDE5D9',
            },
        ],
    };

    return <Bar options={options} data={resultData}/>;
}
